import pick from 'lodash/pick'
import objects from '@/objects'

export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: 'creating',
    },
    schema: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      commonFields: [],
      entity: null,
      errors: {},
    }
  },
  computed: {
    oldEntity() {
      return this.entity ? this.$store.getters[`${this.entity.target}sById`][this.entity.id] : null
    },
    fields() {
      return this.entity ? this.entity.getFields(this.mode, this.schema) : {}
    },
    visibleFields() {
      const visibleFields = {}
      for (const prop in this.fields) {
        if (!this.fields[prop].hidden) {
          visibleFields[prop] = this.fields[prop]
        }
      }
      return visibleFields
    },
  },
  watch: {
    entity: {
      deep: true,
      handler() {
        this.handler()
      },
    },
  },
  methods: {
    handler() {
      this.$emit('input', this.entity)
      this.errors = this.entity.validate(this.mode) || {}
    },
    createEntity(newProps = {}) {
      const inheritProps = pick(this.entity, this.commonFields)
      this.entity = objects[this.object].create({...inheritProps, ...newProps})
    }
  },
  created() {
    this.createEntity(this.$attrs.value)
  },
}
